import React__default from 'react';
import styled from 'styled-components';
import { getSpacing, noop } from '../../../../utils/index.js';
import { Chip } from '../../../Chip/Chip.js';

const TagList = styled.span `
  display: flex;
  align-items: flex-start;

  > * {
    margin: ${getSpacing('s00', 's01')};
  }
`;
function MultiValueList({ values, onRemove, placeholder }) {
    return (React__default.createElement(TagList, null, values.length === 0
        ? placeholder
        : values.map((value) => (React__default.createElement(Chip, { onClick: noop, onRemove: onRemove, label: value.label, value: String(value.value), key: String(value.value), "data-testid": `${String(value.value)}-chip`, selected: true, showClose: true })))));
}

export { MultiValueList };
